import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";

let env = process.env.REACT_APP_B2B_API_BASE_URL;

export const getEmployeesList = async (data) => {
  const url = `${env}${API_ENDPOINT.Employee.api}/?companyId=${data?.companyId}&pageSize=${data?.pageSize}&page=${data?.page}&search=${data?.search}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
